import { useNavigate } from "react-router";
import { displayAcknowledgeDate, getTrendClass } from "../../helpers/renderHelper";
import { User } from "../../models/User";
import { isEmpty, first } from 'lodash'
import { Stack } from "react-bootstrap";


const DriverCard = ({user, onClick, isSummary = false, isFirst = false, isLast = false, carouselMode = false, navigateLeft, navigateRight}:
	{user:User|undefined, onClick?:(any)=>void, isSummary?:boolean, isFirst?:boolean, isLast?:boolean, carouselMode?:boolean, navigateLeft?:(any)=>void, navigateRight?:(any)=>void}) => {

	const score = user?.scorecard
	const trendClass = getTrendClass(score?.trend, "fs-7")

	var background = "bg-primary"
	var iconClass = "bi-exclamation-octagon-fill"
	var color = "white"
	if (score && score.currentScore) {
		if (score.currentScore <= 60) {
			background = "bg-danger"
		} else if ( score?.currentScore <= 89) {
			background = "bg-warning"  
			color = "black"
			iconClass = "bi-exclamation-triangle-fill"
		} else if(score?.currentScore >= 90){
			background = "bg-success" 
			iconClass = "bi-hand-thumbs-up-fill"
		}
	}

	if (user === undefined) {
		return <div />
	}

	var contentWidth = "58vw"
	const showLeftArrow = !isFirst
	const showRightArrow = (isSummary || !isLast)

	const auxillaryStyle = {alignSelf:'center', marginLeft:'auto', marginRight:'auto'}
	const iconStyle = { width:`${carouselMode ? '65px' : '55px'}`, marginLeft: `${carouselMode ? '0px' : '15px'}` ,color: color, marginRight: "0.65rem",alignSelf:'center',display:'flex', justifyContent:'center', borderRadius: "0.25rem"}

	return (
		<div className="card tile w-100" onClick={ onClick }>
			<Stack direction="horizontal">
				{ carouselMode && <div onClick={showLeftArrow ? navigateLeft : () => {}} style={{ width:"40px", display:'flex'}}><i className={showLeftArrow ? "fa-solid fa-chevron-left fs-7 mt-0" : ""} style={auxillaryStyle}></i></div> }
				<div className={`${background}`} style={iconStyle}> <i className={`bi ${iconClass} fa-2x`}></i> </div>
				<div style={{width:'85%'}}>
					<div className="row g-0" style={{ color: 'white', display:'flex', width:contentWidth}} >
						<div className="fs-5 mb-sm-0" style={{overflow:"hidden", whiteSpace:'nowrap', textOverflow:'ellipsis'}} >{`${user?.firstName} ${user?.lastName}`}</div>
						<div className="fs-6 mt-sm-0" style={{marginTop:-5}}>{`Score: ${score?.currentScore ?? '-  '} `}<i className={trendClass}></i></div>
						<div className="fs-8 fst-italic mt-sm-0" style={{marginBottom:5}} ><i className="fa-solid fa-square-check icn-orange" />&nbsp;&nbsp;{score?.acknowledgment ? displayAcknowledgeDate(score?.acknowledgment?.acknowledgedDate) ?? "Not Acknowledged" : "Not Required"}</div>
					</div>
				</div>
				<div  onClick={showRightArrow ? navigateRight : () => {}} style={{ width:50, height:50, display:'flex'}}><i className={showRightArrow ? "fa-solid fa-chevron-right fs-7 mt-0" : ""} style={auxillaryStyle}></i></div>
			</Stack>
		</div>
	)	
	
}

export default DriverCard;